//FIXME: This can easily be made reuseable or use existing functions
//close fiter in scheduling modal just a quick addition for now, this will be refactored and removed in the future
$('a.toggleFilter').on('click', function () {
  $('#calendarFilter').css('display', 'none');
});
